<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <Breadcrumbs :items="breadcrumbs" page_title="course" />
      <!-- <v-system-bar height="60px" class="card-header-system-bar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
          >Course</label
        >
      </v-system-bar> -->

      <v-layout row align-center class="ml-7 mt-10">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <title-block
            :relative="$vuetify.breakpoint.name !== 'xs' ? true : false"
            width="250"
            height="60"
            >{{ "Course" }}</title-block
          >
        </v-flex>
      </v-layout>

      <v-sheet class="px-7 my-5">
        <v-row no-gutters>
          <v-col cols="12" xs="12" sm="6" class="d-flex align-center">
            <v-text-field
              outlined
              dense
              hide-details
              style="border-radius: 8px; border-color: #c0c0c0"
              clearable
              prepend-inner-icon="mdi-magnify"
              placeholder="search"
              v-model="search"
            ></v-text-field>

            <v-btn
              min-width="120"
              height="40"
              class="text-capitalize btn_hover_effect ml-7"
              style="
                color: #ffff;
                border: 1px solid #a6cc39;
                border-radius: 8px;
                font-size: 16px;
              "
              color="#A6CC39"
              >{{ $t("search") }}</v-btn
            >
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            class="d-flex justify-end align-center"
          >
            <v-btn
              min-width="120"
              height="40"
              class="text-capitalize btn_hover_effect"
              style="color: #ffff; border: 1px solid #a6cc39; border-radius: 8px;font-size: 16px;"
              color="#A6CC39"
              @click="AddNewCourse"
              >{{ "Add New" }}</v-btn
            >
          </v-col>
        </v-row>

        <v-row no-gutters class="my-4">
          <v-col>
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="courseItems"
              hide-default-footer
              :search="search"
              @page-count="pageCount = $event"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              no-data-text="No data available"
            >
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.courseName="{ item }">
                <p
                  style="
                    width: 250px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                  class="mb-0"
                >
                  {{ item.courseName }}
                </p>
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.description="{ item }">
                <p
                  style="
                    width: 250px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                  class="mb-0"
                  v-for="(subItem, i) in item.videoList"
                  :key="i"
                >
                  {{ i + 1 + "." }}{{ subItem.videoName }}
                </p>
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-center" style="margin-top: -5px">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text v-bind="attrs" v-on="on" class="editbtn">
                        <v-icon style="color: #424242"
                          >mdi-dots-vertical</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list class="d-flex flex-column align-start">
                      <v-list-item class="list-item-padding">
                        <v-btn
                          color="#424242"
                          style="
                            font-size: 16px;
                            width: 100px;
                            justify-content: left;
                          "
                          text
                          class="text-capitalize"
                          @click="EditCourse(item)"
                        >
                          <v-icon left>mdi-square-edit-outline</v-icon>
                          {{ $t("edit") }}
                        </v-btn>
                      </v-list-item>
                      <v-list-item class="list-item-padding">
                        <v-btn
                          color="#FF6060"
                          style="
                            font-size: 16px;
                            width: 100px;
                            justify-content: left;
                          "
                          text
                          class="text-capitalize"
                          @click="checkAssignmentDelete(item)"
                        >
                          <v-icon left>mdi-delete-outline</v-icon>
                          {{ $t("delete") }}
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col
            cols="12"
            xs="12"
            sm="9"
            md="9"
            xl="10"
            class="d-flex align-center"
          >
            <div class="d-flex text-left pl-1">
              <v-pagination
                circle
                v-model="page"
                class="pagination"
                :length="pageCount"
              ></v-pagination>
            </div>
          </v-col>

          <v-col
            cols="12"
            xs="12"
            sm="3"
            md="3"
            xl="2"
            class="d-flex align-center justify-end"
          >
            <p class="mb-0 pr-4">{{ "Show" }}</p>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  width="70"
                  v-bind="attrs"
                  v-on="on"
                  style="border: 1px solid #c0c0c0; opacity: 1"
                  class="text-capitalize mt-1 mr-3"
                  outlined
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in paginationCount"
                  :key="index"
                  @click="itemsPerPage = item.title"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card>

    <!-- Delete -->
    <v-dialog v-model="ShowDeleteDialog" width="500">
      <v-card>
        <v-card-title
          style="
            font-size: 25px;
            color: #363636;
            height: 84px;
            font-weight: bold;
          "
          class="justify-start"
        >
          <p class="mb-0">{{ "Delete Confirmation" }}</p>
        </v-card-title>

        <v-card-text>
          <p
            class="mb-0"
            style="font-size: 20px; color: #363636; text-align: left"
          >
            {{ "Are you sure you want to delete " }} "Course #{{ editData.id }}"
            ?
          </p>
        </v-card-text>

        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize"
            style="
              font-size: 16px;
              color: #424242;
              border: 1px solid #c0c0c0;
              border-radius: 8px;
            "
            width="100"
            text
            @click="ShowDeleteDialog = false"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize"
            width="100"
            style="
              font-size: 16px;
              background: #ff6060 0% 0% no-repeat padding-box;
              border-radius: 8px;
              color: #ffffff;
            "
            @click="DeleteCourse()"
            >{{ $t("confirm") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddEditDialog
      v-if="ShowAddEditDialog"
      :edit_course="edit_course"
      :edit_data="editData"
      :ShowDialog="ShowAddEditDialog"
      @cancel="CancelDialog"
      @CloseDialog="CloseDialog"
    />
  </div>
</template>

<script>
import axios from "axios";
import * as moment from "moment/moment";
import EnUrl from "@/api/environment";
import TitleBlock from "@/components/global_component/TitleBlock";
import AddEditDialog from "./AddEditDialog.vue";

export default {
  components: {
    TitleBlock,
    AddEditDialog
  },
  data: () => ({
    edit_course: false,
    editData: {},
    ShowDeleteDialog: false,
    ShowAddEditDialog: false,
    loading: false,
    apiUrl: EnUrl.apiUrl,
    search: null,
    courseItems: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    paginationCount: [
      { title: 10 },
      { title: 20 },
      { title: 30 },
      { title: 50 },
      { title: 100 }
    ],
    breadcrumbs: [
      {
        sidebar_title: "defaultcontent"
      },
      {
        text: "course"
      }
    ]
  }),

  computed: {
    headers() {
      return [
        {
          text: "#",
          value: "no",
          align: "left",
          sortable: false
        },
        {
          text: "courseName",
          align: "left",
          value: "courseName",
          sortable: true
        },
        {
          text: "videoName",
          align: "left",
          value: "description",
          sortable: false
        },
        {
          text: this.$t("startdates"),
          align: "left",
          value: "startDateTime",
          sortable: true
        },
        {
          text: this.$t("enddate"),
          align: "left",
          value: "endDateTime",
          sortable: true
        },
        {
          text: this.$t("action"),
          sortable: false,
          align: "center",
          value: "actions"
        }
      ];
    }
  },

  mounted() {
    this.getAllAssignmentCourseData();
  },

  methods: {
    CancelDialog() {
      this.ShowAddEditDialog = false;
      this.edit_course = false;
      this.editData = {};
    },

    CloseDialog() {
      this.ShowAddEditDialog = false;
      this.edit_course = false;
      this.editData = {};
      this.getAllAssignmentCourseData();
    },

    EditCourse(item) {
      this.edit_course = true;
      this.editData = item;
      this.ShowAddEditDialog = true;
    },

    async DeleteCourse() {
      let self = this;
      await axios
        .post(
          `${self.apiUrl}Assignment/RemoveAssignment?ID=` + self.editData.id
        )
        .then(function(res) {
          self.message = res.data.message;
          self.ShowDeleteDialog = false;
          self.getAllAssignmentCourseData();
        })
        .catch(function(err) {
          throw err;
        });
    },

    async checkAssignmentDelete(item) {
      let self = this;
      self.ShowDeleteDialog = true;
      self.editData = item;
    },

    AddNewCourse() {
      this.ShowAddEditDialog = true;
    },
    async getAllAssignmentCourseData() {
      let self = this;
      self.loading = true;

      let data = {
        createFromDate: "",
        createToDate: "",
        startDate: "",
        endDate: "",
        companyID: "00000000-0000-0000-0000-000000000000"
      };

      await axios
        .post(`${self.apiUrl}Assignment/GetAllAssignment`, data)
        .then(function(response) {
          if (response.data.status == 0) {
            console.log("all course ", response.data.data);
            self.courseItems = response.data.data.map((v, i) => ({
              ...v,
              no: i + 1,
              startDateTime: moment(v.startDateTime)
                .local()
                .format("DD/MM/YYYY"),
              endDateTime: moment(v.endDateTime)
                .local()
                .format("DD/MM/YYYY"),
              status: v.status === true ? "1" : "0"
            }));
          }
          self.loading = false;
        })
        .catch(function(err) {
          throw err;
        });
    }
  }
};
</script>

<style scoped>
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 14px !important;
  color: #424242 !important;
  opacity: 1;
  text-align: center;
  background-color: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
}
::v-deep .v-data-table thead th:first-child {
  border-radius: 8px 0 0 8px;
}
::v-deep .v-data-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}
</style>
